import { Component, input, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Pet } from '../../../shared/models/pet.model';
import { LocationSectionComponent } from './sections/location-section/location-section.component';
import { MedicalHistorySectionComponent } from './sections/medical-history-section/medical-history-section.component';
import { PetSectionComponent } from './sections/pet-section/pet-section.component';
import { VaccineHistorySectionComponent } from './sections/vaccine-history-section/vaccine-history-section.component';

@Component({
  selector: 'app-pet-details',
  imports: [
    PetSectionComponent,
    LocationSectionComponent,
    MedicalHistorySectionComponent,
    VaccineHistorySectionComponent
  ],
  templateUrl: './pet-details.component.html',
  styleUrl: './pet-details.component.scss'
})
export class PetDetailsComponent implements OnInit {
  readonly petId = input.required<string>();
  readonly pet = signal<Pet | null>(null);
  constructor(private readonly route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.pet.set(data['pet'] as Pet);
    });
  }
}
